export default __webpack_public_path__ + "static/media/mirai-tower-top.29603be2.jpg";